import * as React from "react";
import {
  Box,
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  Grid,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import COLORS from "../Utils/colors";

// SVG icons
import { ReactComponent as HomeIcon } from "../Icons/svg/home.svg";
import { ReactComponent as PlacesIcon } from "../Icons/svg/places.svg";
import { ReactComponent as TripsIcon } from "../Icons/svg/trips.svg";
import { ReactComponent as PostIcon } from "../Icons/svg/post.svg";
import VideoLibraryOutlinedIcon from "@mui/icons-material/VideoLibraryOutlined";

const navItems = [
  { label: "Home", icon: <HomeIcon />, path: "/" },
  { label: "Trips", icon: <TripsIcon />, path: "/Trips" },
  { label: "Shorts", icon: <VideoLibraryOutlinedIcon />, path: "/shorts" },
  { label: "Posts", icon: <PostIcon />, path: "/post" },
  { label: "Places", icon: <PlacesIcon />, path: "/allplaces" },
];

export default function FixedBottomNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showNav, setShowNav] = React.useState(true);
  const [lastScrollY, setLastScrollY] = React.useState(() => window.scrollY);

  const currentTabIndex = navItems.findIndex(
    (item) => item.path === location.pathname
  );
  const isNavRoute = navItems.some((item) => item.path === location.pathname);

  // React.useEffect(() => {
  //   let ticking = false;
  //   const handleScroll = () => {
  //     const currentScrollY = window.scrollY;
  //     if (!ticking) {
  //       window.requestAnimationFrame(() => {
  //         setShowNav(currentScrollY <= lastScrollY);
  //         setLastScrollY(currentScrollY);
  //         ticking = false;
  //       });
  //       ticking = true;
  //     }
  //   };
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [lastScrollY]);

  const handleNavChange = React.useCallback(
    (_: React.SyntheticEvent, newValue: number) => {
      navigate(navItems[newValue].path);
    },
    [navigate]
  );

  if (!isNavRoute) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        minWidth: '320px',
        zIndex: 40,
        transition: "bottom 0.3s ease-in-out",
      }}
    >
      <Grid container spacing={0.5} columns={12}>
        {/* left gutter */}
        <Grid
          
          size={{ sm: 2, md: 4 }}
          sx={{ display: { xs: "none", sm: "block" } }}
        />
        {/* main nav */}
        <Grid size={{ xs: 12, sm: 8, md: 4 }}>
          <Paper elevation={6}>
            <BottomNavigation
              value={currentTabIndex}
              onChange={handleNavChange}
              showLabels
              sx={{
                "& .MuiBottomNavigationAction-root": {
                  minWidth: "auto",
                  flex: 1,
                  color: "#7a7485",
                  "& svg": {
                    fontSize: 24,
                    fill: "#7a7485",
                    transition: "fill 0.3s ease",
                  },
                  "& .icon-wrapper": {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "6px 16px",
                    borderRadius: "60px",
                    transition: "all 0.3s ease",
                  },
                },
                "& .MuiBottomNavigationAction-root.Mui-selected": {
                  color: COLORS.primary,
                  "& svg": {
                    fill: "white !important",
                  },
                  "& svg path": {
                    fill: "white !important",
                  },
                  "& .icon-wrapper": {
                    backgroundColor: COLORS.primary,
                  },
                },
              }}
            >
              {navItems.map((item, index) => (
                <BottomNavigationAction
                  key={index}
                  label={item.label}
                  icon={<div className="icon-wrapper">{item.icon}</div>}
                />
              ))}
            </BottomNavigation>
          </Paper>
        </Grid>
        {/* right gutter */}
        <Grid
          size={{ sm: 2, md: 4 }}
          sx={{ display: { xs: "none", sm: "block" } }}
        />
      </Grid>
    </Box>
  );
}
